import { Handle, Position } from '@xyflow/react';
import { CButton } from '@coreui/react';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { useState, useCallback, useEffect } from 'react';
import { X } from 'lucide-react'; 
import { CARD_INFO_TYPE_ENUM } from '@webkit/enums/CardInfoTypeEnum.enum';
export const TYPE_CARD_ENUM = Object.freeze({
  CARD_INFO: 'CARD INFO',
  CARD_TEXT: 'CARD TEXT',
  CARD_LINK: 'CARD LINK',
  /* CARD_SUGGESTION: 'CARD SUGGESTION' */
});

const CardInfoNode = ({ id, data }) => {
  const [errorMsg, setErrorMessage] = useState("")
  const [seeErrorMsg, setSeeErrorMessage] = useState(false)
  
  const { node } = data
  const cardActions = {
    [TYPE_CARD_ENUM.CARD_INFO]: () => navigate(data.node.id + '/create-cardinfo'),
    [TYPE_CARD_ENUM.CARD_TEXT]: () => navigate(data.node.id + '/create-cardtext'),
    [TYPE_CARD_ENUM.CARD_LINK]: () => navigate(data.node.id + '/create-cardlink'),
    //[TYPE_CARD_ENUM.CARD_SUGGESTION]: () => navigate(data.node.id + '/create-cardSuggestion'),
  };
  const navigate = useNavigate();

  //modale per i tipi di card da aggiungere
  const [showTypeModal, setShowTypeModal] = useState(false)
  const [newNodeType, setNewNodeType] = useState()
  const [newNodeTitle, setNewNodeTitle] = useState('')

  const handleSelectType = (type, value) => {
    const { children } = node
    
    if (children.length != 0 && children[0].type == "CARD_INFO" && type != "CARD_INFO") {
      setErrorMessage(t("error.insert_only_voice"))
      setSeeErrorMessage(true)
      return
    }if (children.length != 0 && children[0].type == CARD_INFO_TYPE_ENUM.RECOMMENDED_BY_THE_HOST && type != "CARD_INFO") {
      setErrorMessage(t("error.insert_only_voice"))
      setSeeErrorMessage(true)
      return
    } /* else if (node.type != CARD_INFO_TYPE_ENUM.OTHER_HOST_ACCOMODATION && type == "CARD_SUGGESTION" ) {
      setErrorMessage("non puoi inserire altre card struttura qui, vanno solo in 'Altre proposte'")
      setSeeErrorMessage(true)
      return
    } */ else if (node.type == CARD_INFO_TYPE_ENUM.RECOMMENDED_BY_THE_HOST && type != "CARD_LINK" ) {
      setErrorMessage(t("error.insert_only_link"))
      setSeeErrorMessage(true)
      return
    } else if (children.length != 0 && children[0].type == "CARD_TEXT") {
      setErrorMessage(t("error.no_insert"))
      setSeeErrorMessage(true)
      return
    } else if (children.length != 0 && children[0].type == "CARD_LINK" && type != "CARD_LINK") {
      setErrorMessage(t("error.insert_only_link"))
      setSeeErrorMessage(true)
      return
    } /* else if (node.type == CARD_INFO_TYPE_ENUM.OTHER_HOST_ACCOMODATION && type != "CARD_SUGGESTION") {
      setErrorMessage("puoi inserire solo Card Struttura")
      setSeeErrorMessage(true)
      return
    } */ else {
      setNewNodeType(type)
      setNewNodeTitle(value)
      const action = cardActions[value]
      if (action) {
        action();
      } else {
        console.error('Tipo di card non gestito');
      }
      setShowTypeModal(false)
    }
  }

  const handleDeleteClick = useCallback((e) => {
    e.stopPropagation();
    if (data.onDelete) data.onDelete(id);
  }, [data, id]);

  const buttonStyle = {

    backgroundColor: 'var(--primary-color)',
    paddingVertical: 15,
    paddingHorizontal: 50,
    borderRadius: 25,
    alignItems: 'center'
  }

  return (
    <div style={{
      padding: '12px',
      border: '3px solid var(--primary-color)',
      boxShadow: '0 0 30px var(--primary-color)',
      borderRadius: '15px',
      backgroundColor: 'var(--background-card-color)',
      textAlign: 'center',
    }}>
      {/* pulsante X per eliminare */}
      <button
        onClick={handleDeleteClick}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          background: 'transparent',
          border: 'none',
          color: '#04fff2ff',
          cursor: 'pointer',
        }}
        title="Elimina nodo"
      >
        <X size={13} />
      </button>
      <p
        style={{
          borderBottom: '1px solid var(--primary-color)',
          paddingBottom: '4px',
          color: '#fff',
          fontWeight: '700',
        }}
      >
        {data.node.title}
      </p>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <CButton
          className='text-uppercase nodrag text-white mb-2'
          style={buttonStyle}
          size="sm"
          onClick={(e) => {
            e.stopPropagation();
            setShowTypeModal(true);
          }}
        >
          {t('button.create_card')}
        </CButton>
        <CButton
          className='text-uppercase nodrag text-white'
          style={buttonStyle}
          size="sm"
          onClick={() => 
            navigate(`${data.node.id}/edit-cardInfo`)
          }

        >
          {t('button.edit')}
        </CButton>
      </div>
      {/* Handles per connettere i nodi */}
      <Handle type="target" position={Position.Left} />
      <Handle type="source" position={data.handlePosition || Position.Left} />

      {/* Modal scelta tipo */}
      <Modal show={showTypeModal}
        size="lg"
        alignment='center'
        centered>
        <Modal.Header style={{ borderBottom: '2px solid #c8cccbff' }} className=' d-flex justify-content-between'>
          <Modal.Title>{t('title.choose_node')}</Modal.Title>
          <CButton onClick={() => setShowTypeModal(false)}>
            <i className="fa-solid fa-xmark fs-4 text-light"></i>
          </CButton>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column flex-wrap gap-2 justify-content-center">
          <p dangerouslySetInnerHTML={{ __html: t('text.guideCustomization').replace(/\n/g, '<br/>').replace(/---/g, '<hr/>') }} />
          <div className='w-100 d-flex flex-wrap gap-2 justify-content-center align-items-center'>
          {Object.entries(TYPE_CARD_ENUM).map(([key, value]) => {

            let color;
            let boxShadow;
            let border;
            let text;
            
            // eslint-disable-next-line default-case
            switch (value) {
              case TYPE_CARD_ENUM.CARD_INFO:
                color = 'var(--primary-color)';
                boxShadow = '0 0 30px var(--primary-color)';
                border = '3px solid var(--primary-color)';
                text = t("label.card_info");
                break;

              case TYPE_CARD_ENUM.CARD_LINK:
                color = 'var(--card-link-color)';
                boxShadow = '0 0 30px var(--card-link-color)';
                border = '3px solid var(--card-link-color)';
                text = t("label.card_link");
                break;

              case TYPE_CARD_ENUM.CARD_TEXT:
                color = 'var(--card-text-color)';
                boxShadow = '0 0 30px var(--card-text-color)';
                border = '3px solid var(--card-text-color)';
                text = t('label.card_text');
                break;
            };

            return (
              <button
                key={key}
                style={{ ...buttonStyle, backgroundColor: color, boxShadow: boxShadow, border: border, marginTop: '30px' }}
                onClick={(e) => {
                  e.stopPropagation()
                  handleSelectType(key, value)
                }}
                className={`text-center text-uppercase text-white w-25 ${color}`}
              >
                {text}
              </button>
            )
          })}
          </div>
          {seeErrorMsg ? <div className='mt-4 text-danger'>{errorMsg}</div> : null}
        </Modal.Body>
        <Modal.Footer style={{ borderTop: 'none' }}>

        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CardInfoNode;
